module.exports = __webpack_public_path__ + "static/media/pause.f7169f7a.svg";